import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Sls from "./components/Sls";
import Upload from "./pages/Upload";
import Preview from "./pages/Preview";
import VideoView from "./pages/VideoView";

import "./App.css";

function App() {
  const [url, setUrl] = useState("");
  return (
    <div className="App">
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/sls" element={<Sls />} />
        <Route path="/sls/upload" element={<Upload setUrl={setUrl} />} />
        <Route path="/sls/upload/preview/:id" element={<Preview url={url} />} />
        <Route path="/video/:id" element={<VideoView />} />
      </Routes>
    </div>
  );
}

export default App;
